import React, { useEffect, useState } from 'react';
import {
   BrowserRouter as Router,
   Switch,
   Route,
   Link,
   Redirect,
   useHistory,
   useRouteMatch,
   useParams,
   useLocation,
} from 'react-router-dom';
import MainLayout from '../../components/Layout/Main';
import { PrivateRoute } from '../../configs/helpers/PrivateRoute';
import SystemAdmin from './Admin/SystemAdmin';
import DashBoard from './Dashboard/DashBoard';
import Import from './Import/Import';
import Rule from './Rule/Rule';
import Maintenance from '../../components/Other/Maintenance';
import Activity from './Activity/Activity';
import HrWallet from './Wallet/HrWallet';
import BankWallet from './Wallet/BankWallet';
import PointReason from './Point/PointReason';
import TransferPointToBankWallet from './Point/TransferPointToBankWallet';
import CatagoryManagement from './Raas/CatagoryManagement';
import RaasManagement from './Raas/RaasManagement';
import RedeemptionHistory from './Raas/RedeemptionHistory';
import StockManagement from './Raas/StockManagement';
import PermissionManagement from './Admin/PermissionManagement';
import PageNotFound from '../../components/Other/PageNotFound';
import DashboardPointAndRedeem from './Dashboard/DashBoard-1-PointAndRedeem';
import DashboardActivity from './Dashboard/DashBoard-2-Activity';
import DashBoardProjectDepartment from './Dashboard/DashBoard-3-ProjectDepartment';
import DashboardPointCompare from './Dashboard/DashBoard-4-PointCompare';
import DashboardEmployeeAction from './Dashboard/Dashboard-5-EmployeeAction';
import DashboardEmployeePopulation from './Dashboard/Dashboard-6-EmployeePopulation';
import DashboardActivityByDepartment from './Dashboard/Dashboard-7-ActivityByDepartment.jsx';
import DashboardTop10participants from './Dashboard/Dashboard-8-Top10Participants';
import ReportRedeemtion from './Report/ReportRedeemtion';
import ReportStock from './Report/ReportStock';
import ReportCollectPoint from './Report/ReportCollectPoint';
import HistoryReport from './Report/HistoryReport';
import ManageApproveProcess from './Approve/ManageApproveProcess';
import ManageLimitPoint from './Limit/ManageLimitPoint';
import Survey from './Survey/Survey';

import DashboardPointAndRedeemReport from './Dashboard/ReportExample/DashBoard-1-PointAndRedeem';
import DashboardActivityReport from './Dashboard/ReportExample/DashBoard-2-Activity';
import DashboardProjectDepartmentReport from './Dashboard/ReportExample/DashBoard-3-ProjectDepartmentReport';
import DashboardPointCompareReport from './Dashboard/ReportExample/DashBoard-4-PointCompare';
import DashboardPointEmployeeActionReport from './Dashboard/ReportExample/DashBoard-5-EmployeeAction';
import DashboardActivityByDepartmentReport from './Dashboard/ReportExample/DashBoard-7-ActivityByDepartment';
import DashboardEmployeePopulationReport from './Dashboard/ReportExample/DashBoard-6-EmployeePopulation';
import DashboardTop10Participantscopy from './Dashboard/ReportExample/DashBoard-8-Top10Participantscopy';

export default (props) => {
   let { path, url } = useRouteMatch();
   let { topicId } = useParams();
   const location = useLocation();
   const RenderTopic = () => {
      switch (location.pathname) {
         case '/private':
            return <DashBoard />;
         case '/private/admin/permission':
            return <PermissionManagement />;
         case '/private/admin/permission/:topicId':
            return <PermissionManagement />;
         case '/private/admin/systemadmin':
            return <SystemAdmin />;
         case '/private/activity':
            return <Activity />;
         case '/private/rule':
            return <Rule />;
         case '/private/import':
            return <Import />;
         case '/private/point/pointreason':
            return <PointReason />;
         case '/private/point/transferPointtobankwallet':
            return <TransferPointToBankWallet />;
         case '/private/point/wallethr':
            return <HrWallet />;
         case '/private/point/walletbank':
            return <BankWallet />;
         case '/private/raas/catagorymanagement':
            return <CatagoryManagement />;
         case '/private/raas/raasmanagement':
            return <RaasManagement />;
         case '/private/raas/redeemptionhistory':
            return <RedeemptionHistory />;
         case '/private/raas/stockmanagement':
            return <StockManagement />;
         default:
            return <Maintenance />;
      }
   };

   return (
      <Switch>
         <Route path={'/private/dashboard/point-and-redeem/report'}>
            <DashboardPointAndRedeemReport />
         </Route>
         <Route path={'/private/dashboard/point-compare/report'}>
            <DashboardPointCompareReport />
         </Route>
         <Route path={'/private/dashboard/activity/report'}>
            <DashboardActivityReport />
         </Route>
         <Route path={'/private/dashboard/project-department/report'}>
            <DashboardProjectDepartmentReport />
         </Route>
         <Route path={'/private/dashboard/employee-action/report'}>
            <DashboardPointEmployeeActionReport />
         </Route>
         <Route path={'/private/dashboard/employee-population/report'}>
            <DashboardEmployeePopulationReport />
         </Route>
         <Route
            path={'/private/dashboard/activity-organized-by-department/report'}
         >
            <DashboardActivityByDepartmentReport />
         </Route>
         <Route path={'/private/dashboard/top-10-participants/report'}>
            <DashboardTop10Participantscopy />
         </Route>
         <Route path={'/private'}>
            <MainLayout onToggleDark={props.onToggleDark}>
               {/*<PrivateRoute path={location.pathname} component={RenderTopic} />*/}
               <Switch>
                  <PrivateRoute exact path={'/private/main'}>
                     <DashBoard />
                  </PrivateRoute>
                  <PrivateRoute
                     exact
                     path={'/private/dashboard/point-and-redeem'}
                  >
                     <DashboardPointAndRedeem />
                  </PrivateRoute>
                  <PrivateRoute exact path={'/private/dashboard/activity'}>
                     <DashboardActivity />
                  </PrivateRoute>
                  <PrivateRoute
                     exact
                     path={'/private/dashboard/project-department'}
                  >
                     <DashBoardProjectDepartment />
                  </PrivateRoute>
                  <PrivateRoute exact path={'/private/dashboard/point-compare'}>
                     <DashboardPointCompare />
                  </PrivateRoute>
                  <PrivateRoute
                     exact
                     path={'/private/dashboard/employee-action'}
                  >
                     <DashboardEmployeeAction />
                  </PrivateRoute>
                  <PrivateRoute
                     exact
                     path={'/private/dashboard/employee-population'}
                  >
                     <DashboardEmployeePopulation />
                  </PrivateRoute>
                  <PrivateRoute
                     exact
                     path={
                        '/private/dashboard/activity-organized-by-department'
                     }
                  >
                     <DashboardActivityByDepartment />
                  </PrivateRoute>
                  <PrivateRoute
                     exact
                     path={'/private/dashboard/top-10-participants'}
                  >
                     <DashboardTop10participants />
                  </PrivateRoute>
                  <PrivateRoute exact path={'/private/admin/permission'}>
                     <PermissionManagement />
                  </PrivateRoute>
                  {/*<PrivateRoute path={'/private/admin/permission/:topicId'}>*/}
                  {/*  <PermissionManagement />*/}
                  {/*</PrivateRoute>*/}
                  <PrivateRoute exact path={'/private/admin/systemadmin'}>
                     <SystemAdmin />
                  </PrivateRoute>
                  <PrivateRoute exact path={'/private/activity'}>
                     <Activity />
                  </PrivateRoute>
                  <PrivateRoute exact path={'/private/rule'}>
                     <Rule />
                  </PrivateRoute>
                  <PrivateRoute exact path={'/private/import'}>
                     <Import />
                  </PrivateRoute>
                  <PrivateRoute exact path={'/private/point/pointreason'}>
                     <PointReason />
                  </PrivateRoute>
                  <PrivateRoute
                     exact
                     path={'/private/point/transferPointtobankwallet'}
                  >
                     <TransferPointToBankWallet />
                  </PrivateRoute>
                  <PrivateRoute exact path={'/private/point/wallethr'}>
                     <HrWallet />
                  </PrivateRoute>
                  <PrivateRoute exact path={'/private/point/walletbank'}>
                     <BankWallet />
                  </PrivateRoute>
                  <PrivateRoute exact path={'/private/raas/catagorymanagement'}>
                     <CatagoryManagement />
                  </PrivateRoute>
                  <PrivateRoute exact path={'/private/raas/raasmanagement'}>
                     <RaasManagement />
                  </PrivateRoute>
                  <PrivateRoute exact path={'/private/raas/redeemptionhistory'}>
                     <RedeemptionHistory />
                  </PrivateRoute>
                  <PrivateRoute exact path={'/private/raas/stockmanagement'}>
                     <StockManagement />
                  </PrivateRoute>
                  <PrivateRoute exact path={'/private/report/redeem-reward'}>
                     <ReportRedeemtion />
                  </PrivateRoute>
                  <PrivateRoute exact path={'/private/report/reward-total'}>
                     <ReportStock />
                  </PrivateRoute>
                  <PrivateRoute exact path={'/private/report/collect-point'}>
                     <ReportCollectPoint />
                  </PrivateRoute>
                  <PrivateRoute exact path={'/private/report/history-report'}>
                     <HistoryReport />
                  </PrivateRoute>
                  <PrivateRoute exact path={'/private/manage-approve-process'}>
                     <ManageApproveProcess />
                  </PrivateRoute>
                  <PrivateRoute exact path={'/private/manage-limit-point'}>
                     <ManageLimitPoint />
                  </PrivateRoute>

                  <PrivateRoute exact path={'/private/survey'}>
                     <Survey />
                  </PrivateRoute>

                  <PrivateRoute path={'*'}>
                     <PageNotFound />
                  </PrivateRoute>
               </Switch>
            </MainLayout>
         </Route>
      </Switch>
   );
};
